import BaseStep from './BaseStep.js';
import {Helper} from "../../helpers/Helper.js";

export default class TeamsFlows extends BaseStep{
    #teamAction;
	#teamGoal;
    #editingStep;

    _init() {
        this._MultiStepForms.Hook.addAction('addEvents', () => {
            this.#events()
        });

        this._MultiStepForms.Hook.addAction('addWatchers', () => {
            this.#watchers()
        });

		this._MultiStepForms.Hook.addAction('nextStep', (currentStep, nextStep, currentFormWrapper, nextFormWrapper) => {
			this.#teamAction = this._MultiStepForms.formWrapper?.dataset?.action || '';

			if (!this.#teamAction) return;

			if (currentFormWrapper.classList.contains('team-select-step')) {
				const teamSelect = currentFormWrapper.querySelector('select[name="team_id"]');
				if (teamSelect) {
					const selectedOption = teamSelect.options[teamSelect.selectedIndex];
					const teamName = selectedOption.textContent.trim() || '';
					const teamId = selectedOption.value || '';
					const teamImageSrc = selectedOption.getAttribute('data-image-src') || '';
					if (teamName && teamId) {
						this.#saveTeamCardData(
							teamName,
							this.#normalizeStoredTeamImageSrc(teamImageSrc),
							teamId
						);
					}
				} else {
					const teamName = currentFormWrapper.querySelector('input[name="team_name"]')?.value?.trim() || '';
					const teamImageSrc = this.#getExplicitTeamImageSrc();
					if (teamName) {
						this.#saveTeamCardData(teamName, teamImageSrc);
					}

				}

				const currencySelect = this._MultiStepForms.formWrapper.querySelector('select[name="base_currency"]');
				if (currencySelect) {
					let teamGoal = this.#teamGoal || currentFormWrapper.querySelector('input[name="team_campaign_goal_other_amount"]')?.value || document.querySelector('.review-goal-wrapper .goal-input-wrapper .team-goal')?.dataset?.amount || 0;
					teamGoal = new Intl.NumberFormat().format(teamGoal);
					const currencySymbol = currencySelect.options[currencySelect.selectedIndex]?.dataset?.symbol || '';

					this._MultiStepForms.formWrapper.querySelectorAll('.form-group.campaign-currency .form-control-description')?.forEach(el => {
						if (el.innerHTML.includes('{{team_goal}}')) {
							el.innerHTML = el.innerHTML.replace(
								'{{team_goal}}',
								`<span class="team-goal">${currencySymbol + teamGoal}</span>`
							);
						} else if (el.querySelector('.team-goal')) {
							el.querySelector('.team-goal').textContent = currencySymbol + teamGoal;
						}
					});
				}
			}

			if (nextFormWrapper?.classList?.contains('thank-you-step')) {
				requestAnimationFrame(() => {
					if (!this.#applyThankYouParticipantLinkFromStorage()) {
						this.#fetchThankYouParticipantUrl();
					}
				});
				setTimeout(() => {
					if (!this.#applyThankYouParticipantLinkFromStorage()) {
						this.#fetchThankYouParticipantUrl();
					}
				}, 150);
			}

			this.#setTeamPreviewData();
		});

		this._MultiStepForms.Hook.addFilter('doPrevStep', (doPrevStep, currentStep, prevStep) => {
			if (this._MultiStepForms.currentStep === 2) {
				let urlObject = new URL(window.location.href);

				let referrer = urlObject.searchParams.get('referrer') || '';

				if (referrer){
					return false;
				}
			}
			return doPrevStep;
		});

        this._MultiStepForms.Hook.addAction('prevStep', (currentStep, prevStep, currentFormWrapper, prevFormWrapper) => {
            this.#teamAction = this._MultiStepForms.formWrapper?.dataset?.action || '';

            if (this._MultiStepForms.currentStep === 2) {
                let urlObject = new URL(window.location.href);

                let referrer = urlObject.searchParams.get('referrer') || '';

                if (referrer) {
					urlObject.searchParams.delete('referrer');

					if (urlObject.pathname.endsWith('/participate/')) {
						urlObject.pathname += referrer;
					} else if (urlObject.pathname.includes('/participate/')) {
						const pathArray = urlObject.pathname.split('/').filter(e => e);
						pathArray.pop();

						urlObject.pathname = '/' + pathArray.join('/') + '/' + referrer + '/';
					}

					window.location = urlObject.toString();
					return;
				}
            }
        });

        this._MultiStepForms.Hook.addAction('goToStep', (currentStep, prevStep, currentFormWrapper, prevFormWrapper) => {
            this.#teamAction = this._MultiStepForms.formWrapper?.dataset?.action || '';

            if (this._MultiStepForms.currentStep === 2) {
                let urlObject =  new URL(window.location.href);

                let referrer = urlObject.searchParams.get('referrer') || '';

                if (referrer) {
                    urlObject.searchParams.delete('referrer');
                }
            }
        });

        this._MultiStepForms.Hook.addAction('identFormsSubmit', (form, formAction, forms) => {
            if (this.#editingStep) {
                this._MultiStepForms.childClasses.ManageSteps.goToStep(this.#editingStep);
            }
        });

        this._MultiStepForms.Hook.addAction('submitFormSuccess', (response) => {
            this.#applyThankYouParticipantLink(response);
            this.#setTeamPreviewData();
        });

        this._MultiStepForms.Hook.addFilter('doNextStep', (doNextStep, currentStep, nextStep) => {
			if (this.#editingStep) {
				const teamName = this._MultiStepForms.formWrapper.querySelector('input[name="team_name"]')?.value || '';
				const src = this._MultiStepForms.formWrapper.querySelector('input[name="team_featured_image"]')?.files[0] || '';

				if (teamName) {
					this.#saveTeamCardData(
						teamName,
						src ? URL.createObjectURL(src) : ''
					);
				}

				if (this.#editingStep === this._MultiStepForms.currentStep){
					this.#editingStep = null;
				}

				this.#setTeamPreviewData();

                return false;
            }

            return doNextStep;
        }, 5);

        this._MultiStepForms.Hook.addAction('fieldEdit', (fieldsContainer, button) => {
            if (fieldsContainer.classList.contains('preview') && fieldsContainer.classList.contains('team')) {
                // Same control as .button-prev-step: prev runs first, then this hook would set #editingStep to the step we moved back to and block the next Continue.
                if (button?.classList?.contains('button-prev-step')) {
                    return;
                }

                const editStepForm = this._MultiStepForms.formWrapper.querySelector('.team-select-step');

                if (!editStepForm) return;

                this.#editingStep = this._MultiStepForms.currentStep;

                const editStep = this._MultiStepForms.formSteps.indexOf(editStepForm) + 1 || 0;

                this._MultiStepForms.childClasses.ManageSteps.goToStep(editStep);
            }
        })
    }

    #watchers() {
        this.#teamAction = this._MultiStepForms.formWrapper?.dataset?.action || '';

		// Member / fundraiser toggles for "other member" flow.
		// We don't rely on data-form-id; instead we look for the toggle/section structure.
		const memberWrappers = document.querySelectorAll('.signup-form-wrapper');
		memberWrappers.forEach((wrapper) => {
			const memberToggle = wrapper.querySelector('.member-mode-toggle input[name="member_mode"]');
			const fundraiseToggle = wrapper.querySelector('.fundraise-mode-toggle input[name="fundraise_mode"]');

			// Skip wrappers that don't belong to the custom member flow.
			if (!memberToggle && !fundraiseToggle) {
				return;
			}

			const toggleSection = (sections, enabled, selectorFilter) => {
				if (!sections || sections.length === 0) {
					return;
				}
				
				sections.forEach((section) => {
					section.style.display = enabled ? '' : 'none';

					if (!selectorFilter) {
						return;
					}

					const fields = section.querySelectorAll(selectorFilter);
					fields.forEach((field) => {
						// Do not disable the main toggles themselves
						if (field.name === 'member_mode' || field.name === 'fundraise_mode') {
							return;
						}
						field.disabled = !enabled;
					});
				});
			};

			const updateVisibility = () => {
				const memberOn = memberToggle ? memberToggle.checked : true;
				const fundraiseOn = fundraiseToggle ? fundraiseToggle.checked : true;

				// Find ALL sections in the document, not just within the wrapper
				const allMemberSections = document.querySelectorAll('.member-section');
				const allFundraiseSections = document.querySelectorAll('.fundraise-section');

				toggleSection(allMemberSections, memberOn, 'input, select, textarea');
				toggleSection(allFundraiseSections, fundraiseOn, 'input, select, textarea');
			};

			if (memberToggle) {
				memberToggle.addEventListener('change', updateVisibility);
			}

			if (fundraiseToggle) {
				fundraiseToggle.addEventListener('change', updateVisibility);
			}

			updateVisibility();
		});

		this._MultiStepForms.handleEvent('change', 'select.fundraising_campaign_goal', (event, select) => {
			if (select.value === 'other') {
				Array.from(document.querySelectorAll('.fundraising_campaign_other_amount_wrapper'))
					.forEach(e => e.classList.remove('hidden'))
				this._MultiStepForms.formWrapper.querySelectorAll('.form-field-value[data-name="campaign_goal_amount"]')
					.forEach(e => {
						const currency = this._MultiStepForms.formWrapper.querySelector('[name="base_currency"]').value;
						const amount = document.querySelector('input[name="fundraising_campaign_goal_other_amount"]')?.value || 0;
						const name = (document.querySelector('input[name="fundraising_campaign_goal_other_name"]')?.value || '').trim();
						const formatted = Helper.currencyNumberFormatter(amount, currency, 'auto');
						e.textContent = name ? `${formatted} - ${name}` : formatted;
					})
			} else {
				Array.from(document.querySelectorAll('.fundraising_campaign_other_amount_wrapper'))
					.forEach(e => e.classList.add('hidden'))
				this._MultiStepForms.formWrapper.querySelectorAll('.form-field-value[data-name="campaign_goal_amount"]')
					.forEach(e => {
						e.textContent = [...select.selectedOptions][0].label
					})
			}
		})

		this._MultiStepForms.handleEvent('change', '[data-form-id="teams-create-team"] select.fundraising_campaign_goal', (event, select) => {
			if (select.value === 'other') {
				this.#teamGoal = +document.querySelector('[data-form-id="teams-create-team"] input[name="fundraising_campaign_goal_other_amount"]')?.value || 0;
			} else {
				this.#teamGoal = +[...select.selectedOptions][0].dataset.amount;
			}
		})
		this._MultiStepForms.handleEvent('change', 'input[name="fundraising_campaign_goal_other_amount"]', (event, input) => {
			this.#teamGoal = +input.value;
			this._MultiStepForms.formWrapper.querySelectorAll('.form-field-value[data-name="campaign_goal_amount"]')
				.forEach(e => {
					const currency = this._MultiStepForms.formWrapper.querySelector('[name="base_currency"]').value;
					const amount = input.value || 0;
					const name = (document.querySelector('input[name="fundraising_campaign_goal_other_name"]')?.value || '').trim();
					const formatted = Helper.currencyNumberFormatter(amount, currency, 'auto');
					e.textContent = name ? `${formatted} - ${name}` : formatted;
				})
		})
		this._MultiStepForms.handleEvent('change', 'input[name="fundraising_campaign_goal_other_name"]', (event, input) => {
			this._MultiStepForms.formWrapper.querySelectorAll('.form-field-value[data-name="campaign_goal_amount"]')
				.forEach(e => {
					const currency = this._MultiStepForms.formWrapper.querySelector('[name="base_currency"]').value;
					const amount = document.querySelector('input[name="fundraising_campaign_goal_other_amount"]')?.value || 0;
					const name = (input?.value || '').trim();
					const formatted = Helper.currencyNumberFormatter(amount, currency, 'auto');
					e.textContent = name ? `${formatted} - ${name}` : formatted;
				})
		})
    }

    #events() {
        this.#saveTeamCardData();

        this._MultiStepForms.handleEvent('click', 'button[name="action"][value="next-step"]', (event, button) => {
             event.preventDefault();

             const form = button.closest('form');

             form?.querySelector('.submit-form')?.click();
        });

        this.#initSearch();

        this.#initTeamSelect();

		this._MultiStepForms.handleEvent('click', '.team_close_btn', (event,button)=>{
			document.querySelector("select[name='camp-select']").removeAttribute('data-selected-team-id')

		})
    }

    #initSearch(){
        let typing = false;
        let typingTimeout;

        this._MultiStepForms.handleEvent('input', 'form input[type="search"][data-action]:not([disabled])', (event, field) => {

            typing = true;

            clearTimeout(typingTimeout);

            typingTimeout = setTimeout(()=>{
                if (typing) {
                    typing = false;

                    const searchResultsWrapper = field.closest('form')?.querySelector('.search-results[data-search="' + field.id + '"]');

                    if (!searchResultsWrapper) return;

                    const searchForm = document.createElement('form');

                    if (field.value) {

                        searchForm.innerHTML = `
                            <input type="text" name="action" value="${field.dataset.action}">
                            <input type="text" name="search" value="${field.value}">
                            `;

                        const additionalFields = JSON.parse(field.dataset?.additionalFields || '{}');

                        for (const name in additionalFields){
                            searchForm.innerHTML += `<input type="text" name="${name}" value="${additionalFields[name]}">`;
                        }

                        if(field.dataset.action === 'find_teams'){
                            searchResultsWrapper.innerHTML = "<span class='signup-form-loader'></span>";
                        }

                        this._MultiStepForms.submitForm(searchForm, field.dataset.action, false)
                            .then(response => {
                                searchResultsWrapper.innerHTML = response?.results?.html || '';
                            })
                            .catch(response => {
                                if (response?.message) {
                                    this._MultiStepForms.error(null, response.message);
                                }

                                if (response?.results) {
                                    searchResultsWrapper.innerHTML = response.results?.html || '';
                                }
                            });
                    } else {
                        searchResultsWrapper.innerHTML = '';
                    }
                }
            }, 600);

        })
    }

    #initTeamSelect() {
        // Non-team rows merged into the "join an existing team/event" options (e.g.
        // ticketed events) carry a redirect URL instead of a team to join - selecting
        // one should send the user straight there (to buy tickets) rather than
        // continuing the join-team signup flow.
        this._MultiStepForms.handleEvent('change', 'select[name="team_id"]', (event, select) => {
            const redirectUrl = select.options[select.selectedIndex]?.dataset?.redirectUrl;
            if (redirectUrl) {
                window.location.href = redirectUrl;
            }
        });

        this._MultiStepForms.handleEvent('click', '.team-card', (event, card) => {
            const redirectUrl = card.dataset.redirectUrl;
            if (redirectUrl) {
                window.location.href = redirectUrl;
                return;
            }

            const form = card.closest('form');

            card.classList.toggle('is-selected');

            const isSelected = card.classList.contains('is-selected');

            const allCards = form.querySelectorAll('.team-card');

            if (allCards) {
                allCards.forEach(c => {
                    if (c !== card && c.classList.contains('is-selected')) {
                        c.classList.remove('is-selected');
                    }
                });
            }

            const teamIdField = form.querySelector('input[name="team_id"], select[name="team_id"]');

            if (teamIdField) {
                teamIdField.value = isSelected ? card.dataset.value : '';
                teamIdField.dispatchEvent(new Event('change', { bubbles: true }));
            }

            if (isSelected) {
                this.#saveTeamCardData(
                    card.querySelector('.title')?.textContent || '',
                    card.querySelector('img')?.src || '',
                    card.dataset?.value || 0
                );

				this.#teamGoal = +card?.dataset?.goal || 0;
			} else {
                this.#saveTeamCardData();
				this.#teamGoal = 0;
            }

            const elementsForCreateTeam = this._MultiStepForms.formWrapper.querySelectorAll('.create-team');

            if (elementsForCreateTeam){
                elementsForCreateTeam.forEach(el => {
                    el.style.display = isSelected ? 'none' : '';

                    if (el.querySelector('input,textarea,select')) {
                        el.querySelector('input,textarea,select').disabled = isSelected;
                    }
                });
            }

        });
    }

    #applyThankYouParticipantLink(response) {
        const teamId = response?.data?.team_id ?? response?.team_id;
        if (teamId) {
            try {
                sessionStorage.setItem('levcharity_signup_team_id', String(teamId));
            } catch (e) {
                // ignore
            }
        }

        const participantLink = this.#extractParticipantLinkFromResponse(response);
        if (!participantLink) {
            if (!this.#applyThankYouParticipantLinkFromStorage()) {
                this.#fetchThankYouParticipantUrl();
            }
            return;
        }

        this.#storeParticipantLink(participantLink);
        this.#setThankYouParticipantLinkOnDom(participantLink);
    }

    #extractParticipantLinkFromResponse(response) {
        const participateUrl =
            response?.data?.participate_url || response?.participate_url;
        if (participateUrl && participateUrl.length > 0) {
            return participateUrl;
        }

        const participantLink =
            response?.data?.participant_link || response?.participant_link;
        return participantLink && participantLink.length > 0 ? participantLink : '';
    }

    #normalizeThankYouParticipantLink(participantLink) {
        if (!participantLink) {
            return '';
        }

        const step = document.querySelector('.thank-you-step[data-fallback-url]');
        if (!step) {
            return participantLink;
        }

        const fallback = step.getAttribute('data-fallback-url') || '';
        const campaignUrl = step.getAttribute('data-campaign-url') || '';
        const stripTrailingSlash = (value) => (value || '').replace(/\/+$/, '');

        if (campaignUrl && stripTrailingSlash(participantLink) === stripTrailingSlash(campaignUrl)) {
            return fallback || participantLink;
        }

        return participantLink;
    }

    #storeParticipantLink(participantLink) {
        participantLink = this.#normalizeThankYouParticipantLink(participantLink);

        if (!participantLink) {
            return;
        }

        try {
            sessionStorage.setItem('levcharity_signup_participant_url', participantLink);
        } catch (e) {
            // ignore
        }

        this._MultiStepForms.setCookie(
            'levcharity_signup_participant_url',
            participantLink,
            1
        );
    }

    #applyThankYouParticipantLinkFromStorage() {
        let participantLink = '';

        try {
            participantLink =
                sessionStorage.getItem('levcharity_signup_participant_url') || '';
        } catch (e) {
            // ignore
        }

        if (!participantLink) {
            const cookie = this._MultiStepForms.getCookie('levcharity_signup_participant_url');
            if (cookie) {
                try {
                    participantLink = decodeURIComponent(cookie);
                } catch (e) {
                    participantLink = cookie;
                }
            }
        }

        participantLink = this.#normalizeThankYouParticipantLink(participantLink);

        if (!participantLink) {
            return false;
        }

        this.#setThankYouParticipantLinkOnDom(participantLink);
        return true;
    }

    async #fetchThankYouParticipantUrl() {
        const campaignId =
            this._MultiStepForms.formWrapper?.querySelector('input[name="campaign_id"]')?.value ||
            document.querySelector('.thank-you-step input[name="campaign_id"]')?.value ||
            document.querySelector('input[name="campaign_id"]')?.value ||
            '';

        if (!campaignId) {
            return;
        }

        let teamId = '';
        try {
            teamId = sessionStorage.getItem('levcharity_signup_team_id') || '';
        } catch (e) {
            // ignore
        }

        if (!teamId) {
            teamId = this._MultiStepForms.getCookie('levcharity_team_id') || '';
        }

        const formData = new FormData();
        formData.append('action', 'levcharity_signup_participant_url');
        formData.append('campaign_id', campaignId);
        if (teamId) {
            formData.append('team_id', teamId);
        }

        const ajaxUrl =
            typeof admin_ajax !== 'undefined' && admin_ajax?.[0]
                ? `${admin_ajax[0]}?action=levcharity_signup_participant_url`
                : '/wp-admin/admin-ajax.php?action=levcharity_signup_participant_url';

        try {
            const res = await fetch(ajaxUrl, { method: 'POST', body: formData, credentials: 'same-origin' });
            const json = await res.json();
            const participantLink =
                json?.data?.participate_url ||
                json?.data?.url ||
                json?.data?.participant_link ||
                '';

            if (participantLink) {
                this.#storeParticipantLink(participantLink);
                this.#setThankYouParticipantLinkOnDom(participantLink);
            }
        } catch (e) {
            // ignore
        }
    }

    #setThankYouParticipantLinkOnDom(participantLink) {
        participantLink = this.#normalizeThankYouParticipantLink(participantLink);

        if (!participantLink) {
            return;
        }

        const selectors =
            '.thank-you-step .team_campaign_participant_url, .thank-you-step .view_page_button, .thank-you-step .fields-container > a.levcharity_button.primary_button';

        document.querySelectorAll(selectors).forEach((link) => {
            link.href = participantLink;
        });
    }

    #saveTeamCardData(teamName = '', src = '', id = 0) {
        this._MultiStepForms.setCookie('team_card_data', JSON.stringify({
            name: teamName,
            image_src: this.#normalizeStoredTeamImageSrc(src),
            id: id
        }));
    }

    #normalizeStoredTeamImageSrc(src = '') {
        const trimmed = typeof src === 'string' ? src.trim() : '';

        if (!trimmed || this.#isLikelyPageUrlNotImage(trimmed)) {
            return '';
        }

        return trimmed;
    }

    #getExplicitTeamImageSrc(formWrapper = null) {
        const root = formWrapper || this._MultiStepForms.formWrapper;
        if (!root) {
            return '';
        }

        const hasThemeDefault = Boolean(
            root.querySelector('.levcharity-feature-image-theme-default-flag[value="1"]')
        );
        const fileInput = root.querySelector('input[name="team_featured_image"]');
        const hasUploadedFile = Boolean(fileInput?.files?.length);
        const hasUploadPreview = Boolean(
            root.querySelector('.walk4friendship-signup-file-preview img')
        );

        if (!hasThemeDefault && !hasUploadedFile && !hasUploadPreview) {
            return '';
        }

        if (hasThemeDefault) {
            const selectedDefault = root.querySelector('.levcharity-signup-use-theme-default-logo.is-selected');
            const fromButton = selectedDefault?.getAttribute('data-preview-src') || '';
            if (fromButton) {
                return this.#normalizeStoredTeamImageSrc(fromButton);
            }
        }

        if (hasUploadedFile && fileInput.files[0]) {
            return this.#normalizeStoredTeamImageSrc(URL.createObjectURL(fileInput.files[0]));
        }

        const raw =
            root.querySelector('img.w4f-featured-image-tracker')?.src
            || root.querySelector('img[data-name="team_featured_image"]')?.src
            || '';

        return this.#normalizeStoredTeamImageSrc(raw);
    }

    #getDefaultTeamImageSrc() {
        return this._MultiStepForms.formWrapper?.dataset?.defaultTeamImage?.trim() || '';
    }

    #resolveTeamImageSrc(src = '') {
        const trimmed = typeof src === 'string' ? src.trim() : '';

        if (trimmed && !this.#isLikelyPageUrlNotImage(trimmed)) {
            return trimmed;
        }

        return this.#getDefaultTeamImageSrc();
    }

    #isLikelyPageUrlNotImage(url = '') {
        if (!url) {
            return true;
        }

        try {
            const parsed = new URL(url, window.location.origin);
            if (/\.(png|jpe?g|gif|webp|svg|avif)(\?.*)?$/i.test(parsed.pathname)) {
                return false;
            }

            return parsed.pathname.includes('/participate/');
        } catch {
            return false;
        }
    }

    #setTeamPreviewData() {
        if (!this.#teamAction || this.#teamAction === 'join-campaign') return;

        const cardData = this.#getTeamCardData();
        if (!cardData) return;

        this._MultiStepForms.formWrapper.querySelectorAll('.preview.team')?.forEach(preview => {
            const texts = preview.querySelector('.texts');

            if (preview.querySelector('.team-name')){
                preview.querySelector('.team-name').textContent = cardData.name;
            }

            if (preview.querySelector('input[name=team_id]')){
                preview.querySelector('input[name=team_id]').value = cardData.id;
            }

            const previewImageSrc = this.#normalizeStoredTeamImageSrc(cardData.image_src || '');
            const imageBlock = previewImageSrc
                ? `<div class="img-wrapper"><img src="${previewImageSrc}" alt=""></div>`
                : '';

            texts.innerHTML = `
                ${imageBlock}
                <div class="content">
                    <p class="subtitle">${this.#teamAction === 'create-team' ? wp.i18n.__('I am the team captain for:', 'levcharity') : wp.i18n.__('I am a fundraiser for:', 'levcharity')}</p>
                    <p class="title">${cardData.name}</p>
                </div>
                `;
        });

        const thank_you_team_card = this._MultiStepForms.formWrapper.querySelector('.thank-you-step .team-card');

        if (thank_you_team_card) {
            const subtitleEl = thank_you_team_card.querySelector('.subtitle');
            const defaultThankYouSubtitle = subtitleEl?.textContent?.trim() || wp.i18n.__('You have joined:', 'levcharity');
            const thankYouSubtitle = wp?.hooks?.applyFilters
                ? wp.hooks.applyFilters(
                    'levcharity_teams_signup_thank_you_subtitle_js',
                    defaultThankYouSubtitle,
                    {
                        teamAction: this.#teamAction,
                        cardData
                    }
                )
                : defaultThankYouSubtitle;
            thank_you_team_card.querySelector('.title').textContent = cardData.name;
            if (subtitleEl) {
                subtitleEl.textContent = thankYouSubtitle;
            }

            const imgWrapper = thank_you_team_card.querySelector('.img-wrapper');
            const img = thank_you_team_card.querySelector('img');
            const thankYouImageSrc = this.#normalizeStoredTeamImageSrc(cardData.image_src || '');

            if (imgWrapper) {
                if (thankYouImageSrc) {
                    imgWrapper.style.removeProperty('display');
                    if (img) {
                        img.src = thankYouImageSrc;
                        img.style.removeProperty('display');
                    }
                } else {
                    imgWrapper.style.display = 'none';
                    if (img) {
                        img.removeAttribute('src');
                        img.style.display = 'none';
                    }
                }
            }
        }

		if(this.#teamGoal){
			const dataAction = this._MultiStepForms?.formWrapper?.getAttribute('data-action');
			if(dataAction === 'join-team'){
				const goalWrapper = this._MultiStepForms?.formWrapper?.querySelector('.campaign-currency');
				const description = goalWrapper?.querySelector('.form-control-description');
				if(description){
					description.textContent = "Campaign goal is to raise "+ this.#teamGoal +". What will be your personal goal?"
				}
			}
		}
    }

    #getTeamCardData() {
        let cardData = this._MultiStepForms.getCookie('team_card_data');

        if (!cardData) return {};

        try {
            cardData = JSON.parse(cardData);

            if (!cardData) return {};
        } catch (e) {
            if (typeof cardData !== 'object') return; {}
        }

        return cardData;
    }
}
